import React from 'react';
import Download from "react-download-link";

//Filename: Nombre del archivo
//Tipo: Tipo de Archivo (Archivo o Link)
//url: Ruta del Archivo
//label: Etiqueta botón

class DownloadLink extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            url: props.url,
            filename: props.Filename,
            label: props.label,
            tipo: props.tipo
          };
    }

    getDataFromURL = (url) => new Promise((resolve, reject) => {
        fetch(url)
            .then(response => response.blob())
            .then(data => { resolve(data);})
            .catch(reject);
    });

    render() {
        if(this.state.filename === "" || this.state.filename === null){
            return(
            <>
                <label>Sin Archivo</label>
            </>
            );
        } else {
            if(this.state.tipo === 'Link'){
                return(
                    <>
                        <a href={this.state.url} target="_blank" rel="noopener noreferrer" style={{textDecorationLine: 'underline', color: 'blue'}}>Consultar</a>
                    </>
                );
            } else {
                if(this.state.label === ""){
                    return(
                        <>
                            <Download
                                id={this.state.id}
                                label="Descargar"
                                filename={this.state.filename}
                                exportFile={() => Promise.resolve(this.getDataFromURL(this.state.url))}
                            />
                        </>
                    );
                } else {
                    return(
                        <>
                            <Download
                                id={this.state.id}
                                label={this.state.label}
                                filename={this.state.filename}
                                exportFile={() => Promise.resolve(this.getDataFromURL(this.state.url))}
                            />
                        </>
                    );
                }
            }
        }
    }
}

export default DownloadLink;
